import { render, staticRenderFns } from "./DashCollectionLoading.vue?vue&type=template&id=b6f51c9c"
import script from "./DashCollectionLoading.vue?vue&type=script&lang=js"
export * from "./DashCollectionLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports